"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiMarketingStatusesClient = void 0;
const ApiSubClient_1 = require("../../common/client/ApiSubClient");
class ApiMarketingStatusesClient extends ApiSubClient_1.ApiSubClient {
    constructor() {
        super(...arguments);
        this.getAll = () => {
            const marketingStatusesLink = this.getLinkOrThrow('marketingStatuses');
            return this.axios.get(marketingStatusesLink.href).then((it) => {
                try {
                    return it.data._embedded.statuses;
                }
                catch (e) {
                    throw new Error(`Could not unpack marketing statuses, got error: ${e}`);
                }
            });
        };
    }
}
exports.ApiMarketingStatusesClient = ApiMarketingStatusesClient;
//# sourceMappingURL=ApiMarketingStatusesClient.js.map